import React from 'react';
import { Helmet } from "react-helmet";
import { Col, Row, Container, Modal, Button } from 'reactstrap';
import axios from 'axios';
// Local Deps
import './About.scss';
import msgs from '../../../config/messages';
import image from '../../../images/75.jpeg';
import image2 from '../../../images/NFFS.png';
import ntma from '../../../images/ntma.png';
// import dla from '../../../images/dla.png';
// import dod from '../../../images/dod.png';
// import ici from '../../../images/ici.png';
// import metalFact from '../../../images/metalFact.jpg';
// import afCat from '../../../images/afCat.png';
// import castIt from '../../../images/castIt.png';
import fiaLogo from '../../../images/FIA_Logo-20250916-193022.png';
// Video thumbnail placeholder - using existing image for now
import videoThumbnail from '../../../images/aboutvideo.png';
import {
  nffsRoute,
  // dlaRoute,
  // dodRoute,
  ntmaRoute,
  // iciRoute,
  // metalFactRoute,
  // afCatRoute,
  // castItRoute,
  fiaRoute,
} from '../../../config/navigation/routes';

class About extends React.Component {
  static propTypes = {};
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {
      videoModalOpen: false,
      videoUrl: null,
      isLoadingVideo: false,
      error: null,
      videoRef: React.createRef(),
      // Video metadata - using new About ICON video
      video: {
        key: 'About/Connecting_Industry_Government_Opportunites.mp4', // Full path with About/ folder
        title: 'About ICON',
        description: 'Learn more about the ICON portal and its mission.',
        thumbnail: videoThumbnail,
      }
    };
  }

  // Helper to get idToken from cookies
  static getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  // Function to get video URL from API
  getVideoUrl = async (videoKey) => {
    this.setState({ isLoadingVideo: true, error: null });
    try {
      // Get the base API URL from environment variables
      const apiUrl = process.env.REACT_APP_API_HOST;

      // Check if this is an About page video (public access)
      const isAboutVideo = videoKey.startsWith('About/');

      const token = About.getCookie('idToken');

      // For About videos, allow public access without authentication
      // For other videos, require authentication
      if (!isAboutVideo && !token) {
        // Store current page URL for redirect after login
        sessionStorage.setItem('auth_redirect_url', window.location.pathname);

        this.setState({
          error: 'Please log in to view this video. You must be a member to access training content.',
          isLoadingVideo: false
        });
        return null;
      }

      // Build request headers
      const headers = {
        'Content-Type': 'application/json',
      };

      // For About videos: use VISITOR_AUTH_TOKEN if no token, otherwise use actual token
      // For other videos: require a valid token (already checked above)
      if (isAboutVideo) {
        headers.Authorization = token ? `Bearer ${token}` : 'Bearer VISITOR_AUTH_TOKEN';
      } else if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const response = await axios.post(
        `${apiUrl}/api/videos/playback-url`,
        { videoKey },
        { headers }
      );

      // Update state with the video URL
      this.setState({
        videoUrl: response.data.url,
        isLoadingVideo: false
      });

      return response.data.url;
    } catch (error) {
      console.error('Error fetching video URL:', error);
      this.setState({
        error: 'Failed to load video. Please try again later.',
        isLoadingVideo: false
      });
      return null;
    }
  }

  // Open video modal and fetch video URL
  openVideoModal = async (video) => {
    this.setState({ videoModalOpen: true });
    await this.getVideoUrl(video.key);
  }

  // Toggle video modal
  toggleVideoModal = () => {
    this.setState({
      videoModalOpen: !this.state.videoModalOpen,
      videoUrl: null,
      error: null
    });
  }

  render() {
    const { videoModalOpen, videoUrl, isLoadingVideo, error, video } = this.state;

    return (
      <Container fluid className="p-0">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - About Page</title>
          <meta name="description" content="The ICON Portal simplifies the procurement process for cast parts by leveraging a tooling database of defense-related patterns and a database of foundries manufacturing those parts." />
          <meta name="keywords" content="amc icon, american metal casting consortium, cast metals industry, military castings" />
        </Helmet>
        {/* Hero section with gradient background */}
        <div className="nf-about-hero">
          <Container>
            <Row className="align-items-center">
              <Col xs={12} md={6} className="text-center text-md-left">
                <h1 className="nf-about__header">{msgs.About.header}</h1>
                <div className="nf-about__hero-text">
                  {msgs.About.section1.text}
                </div>
              </Col>
              <Col xs={12} md={6} className="text-center">
                <div className="nf-about-hero__video-card">
                  <div
                    className="nf-about-hero__video-thumbnail"
                    onClick={() => this.openVideoModal(video)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.openVideoModal(video);
                      }
                    }}
                    role="button"
                    tabIndex={0}
                    aria-label={`Play ${video.title} video`}
                  >
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="img-fluid"
                    />
                    <div className="nf-about-hero__play-button">
                      <i className="fa fa-play-circle-o" />
                    </div>
                  </div>
                  <div className="nf-about-hero__video-info">
                    <h5>{video.title}</h5>
                    <p className="text-muted">{video.description}</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        {/* Key Features & Benefits Section */}
        <div className="nf-about__features-container">
          <Container>
            <div className="nf-about__features">
              <h3 className="nf-about__features-title">Key Features</h3>
              <div className="nf-about__features-grid">
                <div className="nf-about__feature-card">
                  <h4 className="nf-about__feature-title">Solicitation Review</h4>
                  <p className="nf-about__feature-desc">ICON streamlines the process of reviewing solicitations for cast components, directing them to the appropriate foundries.</p>
                </div>
                <div className="nf-about__feature-card">
                  <h4 className="nf-about__feature-title">Supplier Database</h4>
                  <p className="nf-about__feature-desc">ICON also includes a robust database of foundries, forgers, and machine shops that manufacture parts for the defense industry.</p>
                </div>
                <div className="nf-about__feature-card">
                  <h4 className="nf-about__feature-title">Tooling Database</h4>
                  <p className="nf-about__feature-desc">ICON maintains a database of existing tooling for defense-related cast parts, helping to identify foundries with the necessary equipment.</p>
                </div>
              </div>
              <div className="nf-about__features-grid-bottom">
                <div className="nf-about__feature-card">
                  <h4 className="nf-about__feature-title">Bid Matching</h4>
                  <p className="nf-about__feature-desc">ICON filters and matches part requirements to a supplier&apos;s manufacturing capabilities, saving time and resources.</p>
                </div>
                <div className="nf-about__feature-card">
                  <h4 className="nf-about__feature-title">Promote Inventory</h4>
                  <p className="nf-about__feature-desc">Upload and highlight existing inventory to users and potential buyers within the ICON ecosystem.</p>
                </div>
              </div>
              <h3 className="nf-about__benefits-title">Benefits</h3>
              <div className="nf-about__benefits-grid">
                <div className="nf-about__benefit-card">
                  <h4 className="nf-about__benefit-title">Reduced Lead Times</h4>
                  <p className="nf-about__benefit-desc">By connecting DLA with foundries that already possess the required tooling, ICON can significantly reduce the time it takes to acquire parts.</p>
                </div>
                <div className="nf-about__benefit-card nf-about__benefit-card--double">
                  <h4 className="nf-about__benefit-title">Increased Efficiency &amp; Improved Supply Chain</h4>
                  <p className="nf-about__benefit-desc">ICON helps revitalize and strengthen the supply chain for cast and forged components and simplifies the procurement process for both the DOD and suppliers.</p>
                </div>
                <div className="nf-about__benefit-card">
                  <h4 className="nf-about__benefit-title">Cost Savings</h4>
                  <p className="nf-about__benefit-desc">The platform can lead to lower costs by utilizing existing tooling and fostering competition among suppliers.</p>
                </div>
              </div>
            </div>
          </Container>
        </div>
        <Container className="nf-about-content">
          {/* Background Section with Card */}
          <div className="nf-about-section">
            <div className="nf-about-section__header-container">
              <h2 className="nf-about-section__header">{msgs.About.section2.header}</h2>
              <div className="nf-about-section__underline" />
            </div>
            <Row className="nf-about-card">
              <Col xs={12} md={6}>
                <div className="nf-about-card__content">
                  {msgs.About.section2.text}
                </div>
              </Col>
              <Col xs={12} md={6}>
                <div className="nf-about-card__content">
                  {msgs.About.section2.text2}
                </div>
              </Col>
              <Col xs={12}>
                <div className="nf-about-card__content mt-3">
                  {msgs.About.section2.text3}
                </div>
              </Col>
            </Row>
          </div>
          {/* Partners Section */}
          <div className="nf-about-section">
            <div className="nf-about-section__header-container">
              <h2 className="nf-about-section__header">Partners</h2>
              <div className="nf-about-section__underline" />
            </div>
            <div className="nf-about-partners">
              <Row>
                {/* <Col xs={6} sm={4} md={3} lg={2} className="nf-about-partners__item">
                <a href={dlaRoute} target="_blank" rel="noopener noreferrer" className="nf-about-partners__link">
                  <img src={dla} alt="Defense Logistics Agency" />
                </a>
              </Col> */}
                {/* <Col xs={6} sm={4} md={3} lg={2} className="nf-about-partners__item">
                <a href={dodRoute} target="_blank" rel="noopener noreferrer" className="nf-about-partners__link">
                  <img src={dod} alt="Department of Defense" />
                </a>
              </Col> */}
                <Col xs={6} sm={4} md={3} lg={2} className="nf-about-partners__item">
                  <a href={ntmaRoute} target="_blank" rel="noopener noreferrer" className="nf-about-partners__link">
                    <img src={ntma} alt="National Tooling and Machining Association" />
                  </a>
                </Col>
                {/* <Col xs={6} sm={4} md={3} lg={2} className="nf-about-partners__item">
                <a href={iciRoute} target="_blank" rel="noopener noreferrer" className="nf-about-partners__link">
                  <img src={ici} alt="ICI" />
                </a>
              </Col> */}
                {/* <Col xs={6} sm={4} md={3} lg={2} className="nf-about-partners__item">
                <a href={metalFactRoute} target="_blank" rel="noopener noreferrer" className="nf-about-partners__link">
                  <img src={metalFact} alt="Metal Fact" />
                </a>
              </Col> */}
                {/* <Col xs={6} sm={4} md={3} lg={2} className="nf-about-partners__item">
                <a href={afCatRoute} target="_blank" rel="noopener noreferrer" className="nf-about-partners__link">
                  <img src={afCat} alt="AFCAT" />
                </a>
              </Col> */}
                {/* <Col xs={6} sm={4} md={3} lg={2} className="nf-about-partners__item">
                <a href={castItRoute} target="_blank" rel="noopener noreferrer" className="nf-about-partners__link">
                  <img src={castIt} alt="Cast IT" />
                </a>
              </Col> */}
                <Col xs={6} sm={4} md={3} lg={2} className="nf-about-partners__item">
                  <a href={fiaRoute} target="_blank" rel="noopener noreferrer" className="nf-about-partners__link">
                    <img src={fiaLogo} alt="Forging Industry Association" />
                  </a>
                </Col>
              </Row>
            </div>
          </div>
          {/* From the Desk Section */}
          <div className="nf-about-section">
            <div className="nf-about-section__header-container">
              <h2 className="nf-about-section__header">From the Desk of the Non-Ferrous Founders&#39; Society (NFFS)</h2>
              <div className="nf-about-section__underline" />
            </div>
            <div className="nf-about-card">
              <h3 className="nf-about-card__title">Executive Director:</h3>
              <div className="nf-about-card__content">
                <p>
                  The ICON portal is a unique partnership between e Defense Logistics
                  Agency (DLA) and the Foundry Industry. ICON helps drive a Procurement
                  solution to buyers responsible for acquiring the replacement parts
                  needed by our nation&apos;s defense and military customers, domestic
                  foundries and die casters.
                </p>
                <p>
                  It drives value to stakeholders by providing innovative procurement
                  solutions for defense and military related metal castings. For
                  example, ICON uses a comprehensive industry capabilities database, and
                  the nation&apos;s largest database of foundry defense and military related
                  tooling, to accurately direct bid requests from the DLA to foundries
                  who have existing tooling; or, may not have tooling but are capable of
                  manufacturing that component.
                </p>
                <p>
                  In addition, the resultant goal is to assist DLA in the
                  re-establishment of some of the diminished availability of supply
                  chain parts; and, has made a major contribution to reducing the
                  administrative and production lead times (PLT/ALT), in acquiring
                  replacement metal castings. Many times, at a lower total cost to the
                  Government by utilizing existing tooling and available industry
                  capacity. We are excited about the release of our improved ICON portal
                  and look forward to continuing to serve this country&apos;s warfighters and
                  the foundries that support them.
                </p>
                <div className="nf-about-signature">
                  <div className="nf-about-signature__text">
                    <p className="mb-0">Jerrod A. Weaver</p>
                    <p>Executive Director</p>
                  </div>
                  <div className="nf-about-signature__logo">
                    <a href={nffsRoute} target="_blank" rel="noopener noreferrer">
                      <img src={image} alt="NFFS Logo" className="mb-2" />
                      <div className="nf-about-signature__org">NON-FERROUS FOUNDERS&apos; SOCIETY</div>
                      <img src={image2} alt="NFFS Text Logo" className="mt-2" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>

        {/* Video Modal */}
        <Modal isOpen={videoModalOpen} toggle={this.toggleVideoModal} size="lg" className="video-modal">
          <div className="modal-header">
            <h4 className="modal-title">{video.title}</h4>
            <Button color="link" className="close" onClick={this.toggleVideoModal}>
              <span>&times;</span>
            </Button>
          </div>

          <div className="modal-body">
            {isLoadingVideo && (
              <div className="text-center p-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <p className="mt-2">Loading video...</p>
              </div>
            )}

            {error && (
              <div className="alert alert-danger text-center">
                <p>{error}</p>
                <Button color="primary" onClick={() => this.openVideoModal(video)}>
                  Try Again
                </Button>
              </div>
            )}

            {videoUrl && (
              <React.Fragment>
                {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                <video
                  ref={this.state.videoRef}
                  controls
                  autoPlay
                  className="video-player fullscreen"
                  controlsList="nodownload"
                  playsInline
                  onLoadedMetadata={(e) => {
                    // Update video duration when metadata is loaded
                    const minutes = Math.floor(e.target.duration / 60);
                    const seconds = Math.floor(e.target.duration % 60);
                    const formattedDuration = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
                    console.log(`Video duration: ${formattedDuration}`);
                  }}
                >
                  <source src={videoUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </React.Fragment>
            )}
          </div>
        </Modal>
      </Container>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/pages/static/About/About.jsx